import comp from "./MYPObjectiveRubric";
export default comp;
